import { useCallback } from "react";

import { useQueryClient } from "@tanstack/react-query";

import type { ActivationAlertsContractSocialMediaChannel } from "@similarweb/pro-api-client";

import { apiClient, getQueryKey } from "app/modules/api-client";

import { useDurationContext } from "../../../../contexts/DurationContext";
import { useAlertsParams } from "../../../../hooks/useAlertsParams";

export interface IUsePrefetchSocialPostsParams {
    domain: string;
    socialMediaChannel: ActivationAlertsContractSocialMediaChannel;
}

export const usePrefetchSocialPosts = ({ domain, socialMediaChannel }: IUsePrefetchSocialPostsParams) => {
    const queryClient = useQueryClient();
    const { activationId } = useAlertsParams();
    const duration = useDurationContext();

    return useCallback(() => {
        void queryClient.prefetchQuery({
            queryKey: getQueryKey({
                tag: "Alerts",
                methodName: "activationAlertsSocialMediaGroupPostsDetail",
                args: [
                    {
                        activationId,
                        domain,
                        socialMediaChannel,
                        startDate: duration.forAPI.iso.from,
                        endDate: duration.forAPI.iso.to,
                    },
                ],
            }),
            queryFn: () =>
                apiClient.Alerts.activationAlertsSocialMediaGroupPostsDetail({
                    activationId,
                    domain,
                    socialMediaChannel,
                    startDate: duration.forAPI.iso.from,
                    endDate: duration.forAPI.iso.to,
                }),
        });
    }, [queryClient, activationId, domain, socialMediaChannel, duration.forAPI.iso.from, duration.forAPI.iso.to]);
};
